import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import IconButton from "@material-ui/core/IconButton";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import RowsVat from "./RowsVat";
import React from "react";
import withIntl from "../../../utils/withIntl";
import withStyles from "@material-ui/core/styles/withStyles";

function ExpandableRowSalesArea(props) {
  const [open, setOpen] = React.useState(false);

  const StyledCellHeaderSalesArea = withStyles((theme) => ({
    body: {
      backgroundColor: props.total ? theme.palette.primary.main : theme.palette.primary.light,
      color: theme.palette.common.white,
      verticalAlign: "text-top",
      padding: 3,
      textAlign: "right",
    },
  }))(TableCell);

  const StyledCellHeadPaymentType = withStyles((theme) => ({
    body: {
      backgroundColor: props.total ? theme.palette.primary.main : theme.palette.primary.light,
      color: theme.palette.common.white,
      border: "none",
      verticalAlign: "text-top",
      padding: 3,
      textAlign: "right",
    },
  }))(TableCell);

  return (
    <>
      <TableRow key={props.salesArea.renderedName}>
        <StyledCellHeaderSalesArea>
          {Object.keys(props.salesArea.amountPerPaymentType).length > 0 && (
            <IconButton aria-label="expand row" style={{ color: "white" }} size="small" onClick={() => setOpen(!open)}>
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          )}
        </StyledCellHeaderSalesArea>
        <StyledCellHeaderSalesArea style={{ textAlign: "left" }} component="th" scope="row">
          {props.salesArea.renderedName}
        </StyledCellHeaderSalesArea>
        <StyledCellHeaderSalesArea>{props.salesArea.numberOfBills}</StyledCellHeaderSalesArea>
        <StyledCellHeaderSalesArea />
        <StyledCellHeaderSalesArea>{props.intl.formatMessage({ id: "ex_vat" })}</StyledCellHeaderSalesArea>
        <StyledCellHeaderSalesArea>{props.intl.formatMessage({ id: "vat" })}</StyledCellHeaderSalesArea>
        <StyledCellHeaderSalesArea>{props.intl.formatMessage({ id: "inc_vat" })}</StyledCellHeaderSalesArea>
      </TableRow>

      <RowsVat salesArea={props.salesArea} isTotal={true} amountsObject={props.salesArea.revenue} />
      {props.salesArea.revenue.tipAmount > 0 && (
        <>
          <RowsVat salesArea={props.salesArea} isTip={true} amountsObject={props.salesArea.revenue} />
        </>
      )}
      {/*<RowsVat salesArea={props.salesArea} isTotal={true} amountsObject={props.salesArea.revenue} />*/}

      {open &&
        Object.keys(props.salesArea.amountPerPaymentType).map((paymentType) => {
          return (
            <>
              <TableRow>
                <StyledCellHeadPaymentType style={{ backgroundColor: "#fff" }} />
                <StyledCellHeadPaymentType style={{ textAlign: "left" }}>{paymentType}</StyledCellHeadPaymentType>
                <StyledCellHeadPaymentType>
                  {props.salesArea.amountPerPaymentType[paymentType].count}
                </StyledCellHeadPaymentType>
                <StyledCellHeadPaymentType />
                <StyledCellHeadPaymentType>{props.intl.formatMessage({ id: "ex_vat" })}</StyledCellHeadPaymentType>
                <StyledCellHeadPaymentType>{props.intl.formatMessage({ id: "vat" })}</StyledCellHeadPaymentType>
                <StyledCellHeadPaymentType>{props.intl.formatMessage({ id: "inc_vat" })}</StyledCellHeadPaymentType>
              </TableRow>

              <RowsVat isSubtotal={true} amountsObject={props.salesArea.amountPerPaymentType[paymentType]} />
            </>
          );
        })}
    </>
  );
}

export default withIntl(ExpandableRowSalesArea);
